import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgInstagram = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.87507 2.07029C9.52593 1.97657 14.4741 1.97657 16.1249 2.07029C17.7267 2.15062 19.1456 2.51657 20.3146 3.68582C21.488 4.85507 21.8539 6.27424 21.9297 7.87638C22.0234 9.52761 22.0234 14.4724 21.9297 16.1236C21.8494 17.7258 21.4835 19.1449 20.3146 20.3142C19.1456 21.4879 17.7267 21.8538 16.1249 21.9297C14.4741 22.0234 9.52593 22.0234 7.87507 21.9297C6.27328 21.8494 4.8589 21.4834 3.68544 20.3142C2.51199 19.1449 2.14612 17.7258 2.07027 16.1236C1.97658 14.4724 1.97658 9.52315 2.07027 7.87192C2.15059 6.26978 2.51199 4.85061 3.68544 3.68136C4.8589 2.51211 6.27775 2.14616 7.87507 2.07029ZM12 6.375C8.88642 6.375 6.375 8.88642 6.375 12C6.375 15.1136 8.88642 17.625 12 17.625C15.1136 17.625 17.625 15.1136 17.625 12C17.625 8.88642 15.1136 6.375 12 6.375ZM12 8.25C14.0683 8.25 15.75 9.93173 15.75 12C15.75 14.0683 14.0633 15.75 12 15.75C9.93675 15.75 8.25 14.0683 8.25 12C8.25 9.93173 9.93173 8.25 12 8.25ZM17.625 5.125C16.9347 5.125 16.375 5.6847 16.375 6.375C16.375 7.0653 16.93 7.625 17.625 7.625C18.3153 7.625 18.875 7.06996 18.875 6.375C18.875 5.6847 18.3153 5.125 17.625 5.125Z", fill: props.fill }));
});
export default SvgInstagram;
